import { pathgen } from 'object-path-generator';
export const PdfViewerTestIds = pathgen('PdfViewerTestIds');